import { render, staticRenderFns } from "./onboarding-modal-info.vue?vue&type=template&id=3a59d830&scoped=true"
import script from "./onboarding-modal-info.vue?vue&type=script&lang=js"
export * from "./onboarding-modal-info.vue?vue&type=script&lang=js"
import style0 from "./onboarding-modal-info.vue?vue&type=style&index=0&id=3a59d830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59d830",
  null
  
)

export default component.exports